module.exports = __webpack_public_path__ + "img/企业文化_02.9bb3bc01.png";